import AvailabilityScreen from "./AvailabilityScreen";

export default AvailabilityScreen;
